import styled from 'styled-components'

export const CalendarInputContainer = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.white};
  padding: 10px 18px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  min-height: 28px;
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 15px;
`
export const CalendarInputLabel = styled.p`
  position: absolute;
  margin: 0;
  top: -8px;
  box-sizing: border-box;
  padding: 0px 5px;
  left: 8px;
  font-weight: 600;
  font-size: 13px;
  background: ${({ theme }) => theme.colors.backgroundPrimary};
`
export const CalendarInputSpan = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
`
